export const camposReportes = [
  {
    headerName: 'Línea de Reporte',
    field: 'devolinea',
  },
  {
    headerName: 'Fecha del Servicio',
    field: 'devorepofecha',
  },
  {
    headerName: 'Técnico',
    field: 'tecniconame',
  },
  {
    headerName: 'Estado',
    field: 'configvalor',
  },
  {
    headerName: 'Observaciones',
    field: 'devorepoobs',
  },
];
